// src/Admin/Forbidden.jsx
export default function Forbidden() {
  return (
    <div style={{ padding: 32 }}>
      <h2>403 — Forbidden</h2>
      <p>You don't have access to this area.</p>
    </div>
  );
}
